import { DOCTOR_ROUTES } from "../routes/patientRoutes/routePaths";

export function doctorProfilePath(doctorId) {
  const id = String(doctorId ?? "").trim();
  if (!id) return "/";
  return DOCTOR_ROUTES.PROFILE_DOCTOR(id);
}

export default doctorProfilePath;
